import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tipoServicio/importer/tipoServicioImporterActions';

export default importerReducers(actions);
